import { useCallback, useEffect, useRef, useState } from "react";

// assets
import wavesImage from "../../assets/png/wavesEvent.png";
import modernWomen1 from "../../assets/png/Modern Indian woman wearing a black blazer (1).png";
import modernWomen2 from "../../assets/png/Modern Indian woman wearing a black blazer.png";
import jioCloudLogo from "../../assets/png/JioCloud-Logo.png";

// CSS
import classes from "./UserPhotos.module.css";
import "./UserRegistrationPhotos.css";

// Mui & JDS components
import { Box, Stack } from "@mui/material";
import {
  Text,
  Button,
  Icon,
  Container,
  Tabs,
  TabItem,
  Carousel,
  CarouselSlide,
  Image,
} from "@jds/core";
import ImageGrid from "../../components/Layout/ImageGrid";
import useApiHttp from "../../hooks/use-http";
import PageLoader from "../../components/UI/Loader/PageLoader";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";
import { addParamsURL, getDeviceType } from "../../util/helper";
import decryptUrl from "../../util/img-decryption";
import Loader from "../../components/UI/Loader/Loader";
import { replace, useLocation, useNavigate } from "react-router-dom";
//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
const photosProcessingAlertBarStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 32px)",
  backgroundColor: "#D7EFFF",
  borderRadius: "12px",
  padding: "12px",
  textAlign: "center",
  zIndex: 1,
};

const UserRegistrationPhotos = () => {
  const navigate = useNavigate();
  const loginDetails = useSelector((state) => state.auth.loginDetails)
  const params = new URLSearchParams(useLocation().search);
  const eventId = params.get("eventId");
  const isJitoUser = (localStorage.eventJWT !== '' && localStorage.eventJWT !== 'null') && localStorage.userRole === 'GUEST'
  const bannerThumbnailURl = loginDetails?.bannerThumbnail
    ? decryptUrl(loginDetails?.bannerThumbnail)
    : "";
  const dummyImgArry = [
    "img1",
    "img1",
    "img1",
    "img1",
    "img1",
    "img1",
    "img1",
    "img1",
    "img1",
    "img1",
    "img1",
    "img1",
  ];
  const [data, setData] = useState();
  const [photos, setPhotos] = useState([]);
  const [isPhotoOpen, setIsPhotoOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");
  const [downloadCardShow, setDownloadCardShow] = useState(true);
  const { userClusterApiTrigger } = useSelector(
    (state) => state.userRegistration
  );
  const [currIndex, setCurrIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(1);
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);

  const [imageLoaded, setImageLoaded] = useState(false);

  const { sendRequest: getPhotosAPI, isLoading: isPhotosLoading } =
    useApiHttp();

  const { sendRequest: viewedStatusAPI, isLoading: isViewedStausLoading } =
    useApiHttp();

  // const getAllPhotosHandler = () => {
  //   getAllPhotosAPI(
  //     {
  //       url: `public/images/${eventId}`,
  //       base: "MEDIA",
  //     },
  //     () => { },
  //     (data) => {
  //       setData(data);
  //       setPhotos(data?.data);
  //     }
  //   );
  // }

  const handleViewedStaus = (body = {}) => {
    viewedStatusAPI(
      {
        url: `event-attendee/guest/viewed-status/mark-tab-viewed/${eventId}`,
        method: "POST",
        body: body,
      },
      () => { },
      () => { },
      () => { }
    );
  };
  const getPhotosHandler = (page, selectedTab) => {
    getPhotosAPI(
      {
        url:
          selectedTab == 0
            ? `public/images/${eventId}?page=${0}&size=10`
            : `face/cluster-images/by-user?eventId=${eventId}&page=${0}&size=10`,
        // url:
        //   selectedTab == 0
        //     ? `images?eventId=bad031ce-fff0-404f-9f96-fb395c76b499&folderId=33441DA61ECB959EE063A70F15AC7970&page=${page}&size=20`
        //     : `images?eventId=bad031ce-fff0-404f-9f96-fb395c76b499&folderId=33441DA61ECB959EE063A70F15AC7970&page=${page}&size=20`,
        base: "MEDIA",
      },
      () => { },
      (data) => {
        setLastPage(data?.lastPage);
        setData(data);
        if (page == 0 || selectedTab == 0) {
          setPhotos(data?.data);
          if (selectedTab == 1 && data?.data?.length > 0) {
            handleViewedStaus({ tab: "myPhotos", hasPhotos: true });
          }
          if (selectedTab == 1 && data?.data?.length == 0) {
            handleViewedStaus({ tab: "myPhotos", hasPhotos: false });
          }
        } else {
          setPhotos((pre) => [...pre, ...data?.data]);
        }
      },
      () => { }
    );
  };

  const setImageOpenHandler = (img) => {
    if (photos.length === 0) {
      return;
    }
    setSelectedImg(img);
    setIsPhotoOpen(true);
  };

  //element observer
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (isPhotosLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [isPhotosLoading, lastPage]
  );

  useEffect(() => {
    if (page !== 0 || selectedTab !== 1) {
      setPage(0);
      setSelectedTab(1);
    } else {
      getPhotosHandler(0, 1);
    }
  }, [userClusterApiTrigger]);

  useEffect(() => {
    getPhotosHandler(page, selectedTab);
  }, [page, selectedTab]);
  useEffect(() => {
    if (selectedTab == 1) {
      handleViewedStaus({ tab: "myPhotos", visited: true });
    }
  }, [selectedTab]);
  return (
    <>
      <Box position={"relative"} sx={{ backgroundColor: "#fff" }}>
        {!isPhotoOpen ? (
          <Box>
            {/* <Stack direction="row" py={"12px"} alignItems="center" gap={1}>
              <div
                style={{ display: "flex", cursor: 'pointer' }}
                onClick={() => { window.location.href = `${process.env.REACT_APP_DOMAIN}home` }}
              >
                <Icon ic={"IcBack"} />
                <Text text={localStorage.getItem('eventName')} color="primary-50" />
              </div>
            </Stack> */}
            {/* {!isJitoUser && */}
            <Box p={2}>
              <Text text={localStorage.getItem('eventName')} color="primary-50" />
            </Box>
            {/* } */}
            <Box
              sx={{
                position: "relative",
                width: "100%",
                aspectRatio: "16 / 9",
                overflow: "hidden",
                "& .j-JDSSkeleton-container ": {
                  borderRadius: 0,
                },
              }}
            >
              {bannerThumbnailURl && (
                <img
                  src={bannerThumbnailURl}
                  alt="blurred-banner"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    filter: "blur(20px)",
                    transform: "scale(1.05)",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    transition: "opacity 0.3s ease-in-out",
                    opacity: imageLoaded ? 0 : 1,
                    zIndex: 2,
                  }}
                />
              )}

              {bannerThumbnailURl && (
                <LazyLoadImage
                  src={bannerThumbnailURl}
                  alt="event banner"
                  afterLoad={() => setImageLoaded(true)}
                  width="100%"
                  height="100%"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: imageLoaded ? 1 : 0,
                    transition: "opacity 0.6s ease-in-out",
                    zIndex: 3,
                  }}
                />
              )}
            </Box>
            <Box
              className="album__grid-container"
              sx={{ p: "8px", pb: "86px", position: "relative" }}
            >
              {/* <Box mb={2} px={1}>
                <Text
                  text={`My Photos(${data?.count})`}
                  appearance="body-m-bold"
                />
              </Box> */}
              <Box>
                <Tabs
                  overflow="fit"
                  onChange={(e) => {
                    setSelectedTab(e);
                    setPage(0);
                    setPhotos([]);
                  }}
                  activeTab={selectedTab}
                >
                  <TabItem label="All Photos" />
                  <TabItem label="My Photos" />
                </Tabs>
              </Box>

              {photos.length === 0 && !isPhotosLoading && (
                <Stack alignItems="center" sx={photosProcessingAlertBarStyle}>
                  <Text
                    // text={
                    //   selectedTab == 1
                    //     ? "Your photos are being processed."
                    //     : "Event photos will be shown here."
                    // }
                    text={"Your photos are being processed."}
                    appearance="body-m-bold"
                  />
                  <Text
                    text="They'll be available here shortly."
                    appearance="body-xs"
                  />
                </Stack>
              )}
              {!isPhotosLoading &&
                <ImageGrid
                  images={photos.length === 0 ? dummyImgArry : photos}
                  totalCount={data?.eventPhotosCount}
                  emptyGrid={photos.length === 0}
                  setImgOpen={setImageOpenHandler}
                  setCurrIndex={setCurrIndex}
                  lastElementRef={lastElementRef}
                  // viewMore={data?.eventPhotosCount > 10 || (photos.length === 0 && data?.eventPhotosCount > 0)}
                  viewMore={data?.eventPhotosCount > 10 && photos.length === 10}
                />
              }
              {page !== 0 && isPhotosLoading && (
                <Loader
                  size="small"
                  containerProps={{ style: { marginTop: "16px" } }}
                />
              )}
            </Box>
          </Box>
        ) : (
          <Box
            className="album__view-container"
            sx={{ "& .lazy-load-image-background": { width: "100%" } }}
          >
            <Stack direction="row" p={"12px"} alignItems="center" gap={1}>
              <div
                style={{ display: "flex" }}
                onClick={() => setIsPhotoOpen(false)}
              >
                <Icon ic={"IcBack"} onClick={() => setIsPhotoOpen(false)} />
                {/* <Text
                text={`${selectedImg?.index < 10 ? "0" : ""}${
                  selectedImg?.index
                }/${data?.count}`}
                color="primary-50"
              /> */}
                <Text
                  text={`${currIndex + 1 < 10 ? 0 : ""}${currIndex + 1}/${photos.length < 10 ? 0 : ""
                    }${photos.length}`}
                  color="primary-50"
                />
              </div>
            </Stack>
            {/* <img src={selectedImg?.src} /> */}
            {/* <LazyLoadImage
              src={selectedImg?.src}
              placeholderSrc={selectedImg?.src}
              alt={`imageview${selectedImg?.index}`}
              effect="blur"
              style={{ pointerEvents: "none" }}
            /> */}
            <Box
              sx={{ "& .j-JDSImage-container": { height: "68vh !important" } }}
            >
              <Swiper
                className="mySwiper"
                initialSlide={currIndex}
                onSlideChange={(slider) => {
                  setCurrIndex(slider.activeIndex);
                }}
              >
                {photos.map((src, index) => (
                  <SwiperSlide>
                    <Image
                      src={
                        src?.thumbnailFileSignedPath
                          ? addParamsURL(
                            decryptUrl(src?.reducedFileSignedPath),
                            { size: "s" }
                          )
                          : ""
                      }
                      aspectRatio="9:16"
                      // aspectRatio="16:9"
                      borderRadius="0"
                      contentScale="contain"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </Box>
          </Box>
        )}
        {getDeviceType() !== "Desktop" && (
          <Box
            className={classes["download-app__card"]}
            sx={{
              display: downloadCardShow ? "flex" : "none",
            }}
          >
            <Stack flexDirection="row" alignItems="center" gap="12px">
              <img src={jioCloudLogo} alt="logo" />
              <div className={classes["download-app__card-content"]}>
                <p>
                  Access your event photos plus 50 GB free storage on
                  JioAICloud.
                </p>
              </div>
            </Stack>
            <Stack flexDirection="row" alignItems="center" gap="12px">
              <Button
                label="Download"
                size="small"
                onClick={() => {
                  window.location.href = `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/events/downloadApp?event_id=${eventId}`;
                }}
              />
              <Icon
                ic="IcClose"
                kind="background"
                color="primary-grey-80"
                onClick={() => {
                  setDownloadCardShow(false);
                }}
              />
            </Stack>
          </Box>
        )}
      </Box>
      {isPhotosLoading && page === 0 && <PageLoader open={isPhotosLoading} />}
    </>
  );
};

export default UserRegistrationPhotos;
